import { defineComponent } from 'vue'
import { mapGetters, mapActions } from 'vuex'
import serverConfig from '@/services/config'

export default defineComponent ({
    name: 'WorkerInformation'
    , props: {
        id: Number
    }
    , data: () => ({
        processing: false
    })
    , computed: {
        ...mapGetters('modOhAnalyst', [
            'getEmployeeInfo'
        ])
        , employee () {
            return (this.getEmployeeInfo) ? (this.getEmployeeInfo.data ? this.getEmployeeInfo.data.employee : {}) : {}
        }
        , getAttributeByEmployee () {
            return (key) => {
                return this.employee[key] || this.notApply
            }
        }
        , notApply () {
            return 'N/A'
        }
        , image () {
            return this.employee.image || null
        }
        , src () {
            serverConfig.permisosURL.concat('/'.concat(this.image))
        }
    }
    , beforeMount () {
        this.getData()
    }
    , watch: {
        id: {
            handler() {
               this.getData()
            }
            , deep: true
        }
    }
    , methods: {
        ...mapActions('modOhAnalyst', [
            'actGetEmployeeInfo'
        ])
        , async getData() {
            if (this.id < 1) return
            this.processing = true
            await this.actGetEmployeeInfo(this.id).finally(() => {
                this.processing = false
            })
        }
    }
})